"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ListOrder = _interopRequireDefault(require("./components/ListOrder.vue"));
var _SummaryTour = _interopRequireDefault(require("./components/SummaryTour.vue"));
var _TourForm = _interopRequireDefault(require("./components/TourForm.vue"));
var _tour = require("@/api/tour");
var _moment = _interopRequireDefault(require("moment"));
var _PrintTour = _interopRequireDefault(require("./components/PrintTour.vue"));
var Tour = /*#__PURE__*/function (_Vue) {
  function Tour() {
    var _this;
    (0, _classCallCheck2.default)(this, Tour);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, Tour, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "form", {
      dataTable: [],
      moneyReturnCustomer: 0
    });
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    return _this;
  }
  (0, _inherits2.default)(Tour, _Vue);
  return (0, _createClass2.default)(Tour, [{
    key: "handleCreate",
    value: function () {
      var _handleCreate = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$refs.tourForm.$refs.form.validate();
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", this.$message.error("Fill correct all input"));
            case 8:
              this.$confirm("Bạn chắc chắn muốn xác nhận đơn này?", "Cảnh báo", {
                confirmButtonText: "Có",
                cancelButtonText: "Không",
                type: "warning"
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
                var data;
                return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _this2.loadingButton = true;
                      data = {
                        tour: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this2.form), {}, {
                          date: (0, _moment.default)().format("YYYY-MM-DD"),
                          time: (0, _moment.default)().format("HH:mm")
                        }),
                        shipperIds: _this2.form.shipperIds,
                        orderIds: _this2.form.dataTable.map(function (e) {
                          return e.id;
                        })
                      };
                      _tour.tourApi.create(data).then(function () {
                        _this2.$refs.printTour.handleView(data);
                        _this2.form = {
                          dataTable: [],
                          moneyReturnCustomer: 0
                        };
                        _this2.$notify.success({
                          title: "Thêm tour mới",
                          message: "Successfully"
                        });
                      }).finally(function () {
                        _this2.loadingButton = false;
                      });
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function handleCreate() {
        return _handleCreate.apply(this, arguments);
      }
      return handleCreate;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
Tour = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ListOrder: _ListOrder.default,
    SummaryTour: _SummaryTour.default,
    TourForm: _TourForm.default,
    PrintTour: _PrintTour.default
  }
})], Tour);
var _default = exports.default = Tour;